export { default } from './SectionBenefit';